/* eslint-disable max-len */
import classNames from 'classnames';
import React from 'react';

export const PencilIcon = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => {
  return (
    <i className={classNames('bookriver-icon-PencilIcon', className)} {...props} />
  );
};
